import React from "react";
import { LivechatSubjectType } from "@scrile/api-provider/dist/api/LivechatsProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import { Appointment } from "@scrile/api-provider/dist/projects/webvideo/AppointmentProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/webvideo/UserPublicDataProvider";
import BaseIcon from "components/BaseIcon";
import VideoControlButton from "components/VideoControlButton";
import useProduceConsumeController from "pages/PageAppointmentChat/components/hooks/useProduceConsumeController";
import useViewController from "./viewController";
import AppointmentStreamView from "../AppointmentStreamView";

interface Props {
  produceUser: UserPublicData;
  livechatSubject: Subject<LivechatSubjectType>;
  appointment?: Appointment;
  disableAttachments?: boolean;
}

function ConsumeController({ produceUser, livechatSubject, appointment }: Props) {
  const {
    threadId,
    loading,
    users,
    token,
    produceMediaConstraints,
    onCloseStream,
    onProduceStream,
    onChangeConstraints,
    produceConnection,
    isProducerFinishedStream,
    onProducerFinishedStream,
    audioInputs,
    videoInputs,
    me,
    userList,
    permissions,
  } = useProduceConsumeController(livechatSubject, false);

  const { produce, onStartProduce } = useViewController(
    onChangeConstraints,
    produceMediaConstraints,
    onProduceStream,
    produceConnection,
    !loading
  );

  const controlButton = produce ? undefined : (
    <VideoControlButton
      className="panel-control-buttons__btn"
      name="toggle-cam"
      toggle={produce}
      borderless
      onClick={onStartProduce}
      disabled={loading}
    >
      <BaseIcon>{"cam_off"}</BaseIcon>
    </VideoControlButton>
  );

  return (
    <AppointmentStreamView
      me={produce ? me : null}
      users={users}
      produceUser={produceUser}
      threadId={threadId}
      loading={loading}
      userList={userList}
      streamStartedDate={appointment?.startTime ?? ""}
      streamEndedDate={appointment?.endTime ?? ""}
      token={token}
      audioInputs={audioInputs}
      videoInputs={videoInputs}
      onCloseStream={onCloseStream}
      managedConstraints={produce ? produceMediaConstraints : null}
      onChangeConstraints={onChangeConstraints}
      permissions={permissions}
      slotControlButtons={controlButton}
      isProducerFinishedStream={isProducerFinishedStream}
      onProduceFinishedStream={onProducerFinishedStream}
    />
  );
}

export default ConsumeController;
